/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const StarFill = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <path d="M16,19.5 C15.9239642,19.4990093 15.8489949,19.4819709 15.78,19.45 L10,16.56 L4.22,19.45 C4.06167186,19.5390891 3.86832814,19.5390891 3.71,19.45 C3.56028154,19.3382043 3.48049347,19.1558316 3.5,18.97 L4.5,12.22 L0.65,8.35 C0.515188935,8.22156935 0.464816505,8.02782923 0.52,7.85 C0.578326898,7.67015534 0.733107908,7.53859149 0.92,7.51 L6.67,6.51 L9.55,0.78 C9.64297577,0.619436277 9.8144597,0.520576284 10,0.520576284 C10.1855403,0.520576284 10.3570242,0.619436277 10.45,0.78 L13.33,6.55 L19.08,7.55 C19.2668921,7.57859149 19.4216731,7.71015534 19.48,7.89 C19.5351835,8.06782923 19.4848111,8.26156935 19.35,8.39 L15.53,12.22 L16.53,18.97 C16.5495065,19.1558316 16.4697185,19.3382043 16.32,19.45 C16.2218353,19.5017094 16.1092598,19.5192993 16,19.5 L16,19.5 Z" />
    </BaseSvgIcon>
  )
}

export default StarFill
